<app-images
  (getImagesEvent)="fetchImages($event)"
  [images]="images"
  [totalImages]="totalImages"
  [imagesPerPage]="imagesPerPage"
  [showPaginator]="false"
  [readonly]="true"
></app-images>
